export default "__VITE_ASSET__5e673238__"